<template>
  <div class="page-wrap">
    <div v-if="title">
      <div slot="header" class="clearfix wrap">
        <div class="page-line"></div>
        <div style="width:7px"></div>
        <div class="page-title">{{ title }}</div>
      </div>
    </div>
    <slot/>
  </div>
</template>

<script>
export default {
  name: "PageWrapper",
  props: {
    title: String
  }
};
</script>
<style lang="scss" scoped>
.page-wrap {
  padding: 0px 0px 16px;

  .wrap {
    display: flex;
    align-items: center;
  }

  .page-title {
    font-size: 18px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #10152D;
    line-height: 25px;
  }

  .page-line {
    width: 3px;
    height: 16px;
    background: #0066FF;
    border-radius: 2px;
  }

  [data-theme="theme1"] & {
    //background: #00E9E2;
    .page-title {
      color: #fff;
    }
    .page-line{
      background: #00E7E1;
    }
  }


}
</style>



// WEBPACK FOOTER //
// src/components/PageWrapper/index.vue